import ReactSelect from "react-select";

const styles = {
  control: (styles) => ({
    ...styles,
    borderColor: "#E2E5EC",
    borderWidth: 1,
    borderRadius: 4,
    minHeight: 20,
  }),
  option: (provided) => ({
    ...provided,
    fontFamily: "Poppins",
    fontSize: "8px",
    padding: 4,
  }),
  singleValue: (provided) => ({
    ...provided,
    fontFamily: "Poppins",
    fontSize: "10px",
    padding: 0,
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "1px 5px",
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    display: "none",
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
    padding: 0,
  }),
  placeholder: (provided) => ({
    ...provided,
    fontFamily: "Poppins",
    fontSize: "10px",
  }),
  multiValue: (provided) => ({
    ...provided,
    flexDirection: "row-reverse",
    backgroundColor: "#F3F6F9",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    fontSize: 9,
    padding: "0 7px",
    color: "#595D6E",
  }),
};

const Select = ({ label, options = [], value = null, onChange }) => (
  <div className="inp-wrapper">
    {label && <label>{label}</label>}
    <ReactSelect
      onChange={onChange}
      styles={styles}
      placeholder="Wybierz..."
      options={options || []}
      value={options.find((item) => value === item.value)}
    />
  </div>
);

export default Select;
